/**
 * =============================================================================
 * ADMIN UI API CONSTANTS
 * =============================================================================
 *
 * Constants shared between `./client` and `./fetchWithRetry`. Owning these
 * values here breaks the circular import that would otherwise form:
 *
 *   client.ts            ──imports fetchWithRetry──▶ fetchWithRetry.ts
 *   fetchWithRetry.ts    ──imports a constant──────▶ client.ts
 *
 * That cycle was crashing the bundle at module-init time with
 *   "Cannot access 'DEFAULT_REQUEST_TIMEOUT_MS' before initialization"
 * because fetchWithRetry's `DEFAULT_OPTIONS` literal evaluates the constant
 * on import, but client.ts had not yet finished its first pass when
 * fetchWithRetry's module body ran. The crash blanked the admin UI before
 * either the post-install screen or the authenticated dashboard could render.
 *
 * Keep this module dependency-free (no imports from `./client`,
 * `./fetchWithRetry`, or anything that might transitively import them).
 *
 * =============================================================================
 */

/**
 * Default request timeout in milliseconds (30 seconds).
 * Requests that exceed this duration will be aborted with a user-friendly error.
 * P1-11: AbortController for API Request Timeouts
 */
export const DEFAULT_REQUEST_TIMEOUT_MS = 30000;
